import React from "react";
import SongEditor from "./SongEditor";

export default function EditSongV2() {
  return <SongEditor mode="edit" />;
}
